export { default } from './DiagnosisList';
